import { ReactComponent as facebookIcon } from './assets/facebook.svg';
import { ReactComponent as instagramIcon } from './assets/instagram.svg';
import { ReactComponent as twitterIcon } from './assets/twitter.svg';
import React from "react";

export type FooterSectionType = {
    title: string;
    links: {
        text: string;
        link: string;
        icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>> | undefined;
    }[]
}

// Spanish footer sections
export const FOOTER_SECTIONS_ES: FooterSectionType[] = [
    {
        title: "HumanizeAI",
        links: [
            {
                text: "Humanizer + AI Detector",
                link: '/',
            },
            {
                text: "ShadowChat",
                link: "/generation/shadow-chat",
            },
            {
                text: "Pricing",
                link: "/pricing",
            }
        ]
    },
    {
        title: "Account",
        links: [
            {
                text: "Login",
                link: '/auth',
            },
            {
                text: "Sign Up",
                link: "/auth",
            },
            {
                text: "Support",
                link: "/support"
            }
        ]
    },
    {
        title: "Free Tools",
        links: [
            {
                text: "Text Summarizer",
                link: '/summarizer',
            },
            {
                text: "AI Paragraph Generator",
                link: '/paragraph-generator',
            },
            {
                text: "Text Message Generator",
                link: '/text-message-generator',
            },
            {
                text: "AI Abstract Generator",
                link: '/abstract-generator',
            }
        ]
    },
    {
        title: "Links",
        links: [
            {
                text: "Humanizador de Texto",
                link: '/humanizador-de-texto',
            }
        ]
    },
    {
        title: "SOCIAL",
        links: [
            {
                text: "Instagram",
                link: 'https://instagram.com/humanizeainow ',
                icon: instagramIcon
            },
            {
                text: "Twitter",
                link: 'https://twitter.com/humanizeainow ',
                icon: twitterIcon
            },
            {
                text: "Facebook",
                link: "https://www.facebook.com/humanizeainow ",
                icon: facebookIcon
            }
        ]
    }
]

// Portuguese footer sections
export const FOOTER_SECTIONS_PT: FooterSectionType[] = [
    {
        title: "HumanizeAI",
        links: [
            {
                text: "Humanizer + AI Detector",
                link: '/',
            },
            {
                text: "ShadowChat",
                link: "/generation/shadow-chat",
            },
            {
                text: "Pricing",
                link: "/pricing",
            }
        ]
    },
    {
        title: "Account",
        links: [
            {
                text: "Login",
                link: '/auth',
            },
            {
                text: "Sign Up",
                link: "/auth",
            },
            {
                text: "Support",
                link: "/support"
            }
        ]
    },
    {
        title: "Free Tools",
        links: [
            {
                text: "Text Summarizer",
                link: '/summarizer',
            },
            {
                text: "AI Paragraph Generator",
                link: '/paragraph-generator',
            },
            {
                text: "Text Message Generator",
                link: '/text-message-generator',
            },
            {
                text: "AI Abstract Generator",
                link: '/abstract-generator',
            }
        ]
    },
    {
        title: "Links",
        links: [
            {
                text: "Humanizar Texto com IA",
                link: '/Humanizar-Texto-com-IA',
            }
        ]
    },
    {
        title: "SOCIAL",
        links: [
            {
                text: "Instagram",
                link: 'https://instagram.com/humanizeainow ',
                icon: instagramIcon
            },
            {
                text: "Twitter",
                link: 'https://twitter.com/humanizeainow ',
                icon: twitterIcon
            },
            {
                text: "Facebook",
                link: "https://www.facebook.com/humanizeainow ",
                icon: facebookIcon
            }
        ]
    }
]

export const FOOTER_SECTIONS: FooterSectionType[] = [
    {
        title: "HumanizeAI",
        links: [
            {
                text: "Humanizer + AI Detector",
                link: '/',
            },
            {
                text: "ShadowChat",
                link: "/generation/shadow-chat",
            },
            {
                text: "Pricing",
                link: "/pricing",
            }
        ]
    },
    {
        title: "Account",
        links: [
            {
                text: "Login",
                link: '/auth',
            },
            {
                text: "Sign Up",
                link: "/auth",
            },
            {
                text: "Support",
                link: "/support"
            }
        ]
    },
    {
        title: "Free Tools",
        links: [
            {
                text: "Text Summarizer",
                link: '/summarizer',
            },
            {
                text: "AI Paragraph Generator",
                link: '/paragraph-generator',
            },
            {
                text: "Text Message Generator",
                link: '/text-message-generator',
            },
            {
                text: "AI Abstract Generator",
                link: '/abstract-generator',
            }
        ]
    },
    {
        title: "Links",
        links: [
            {
                text: "Bypass AI Detection",
                link: '/bypass-ai-detection',
            },
            {
                text: "Transform Your Writing",
                link: '/transform-your-writing',
            },
            {
                text: "Create Undetectable Content",
                link: '/create-undetectable-content',
            },
            {
                text: "GPTZero Alternative",
                link: '/gptzero-alternative',
            }
        ]
    },
    {
        title: "SOCIAL",
        links: [
            {
                text: "Instagram",
                link: 'https://instagram.com/humanizeainow ',
                icon: instagramIcon
            },
            {
                text: "Twitter",
                link: 'https://twitter.com/humanizeainow ',
                icon: twitterIcon
            },
            {
                text: "Facebook",
                link: "https://www.facebook.com/humanizeainow ",
                icon: facebookIcon
            }
        ]
    }
]
